import { BrowserRouter, useNavigate } from "react-router-dom";
import { Routes } from "./routes/Routes";
import { GlobalStyle } from "./styles/globalStyles";
import "./styles/tailwindstyles.css";
import { initialTheme, ThemeContext } from "./context/themeContext";
import { useEffect, useState } from "react";
import { getThemColors } from "./http/asset-management-services";
import { updateTheme } from "./context/Themes";
import LoaderContainer from "./components/shared/loaderContainer/LoaderContainer";
import { themeSchema } from "./constants/ThemeConstants";
import { useCheckMobileScreen } from "./util/customHooks";
import { RouteConstants } from "./constants/RouteConstants";

export const App = (): JSX.Element => {
  const [theme, setTheme] = useState(initialTheme);
  const [rawTheme, setRawTheme] = useState(null);
  const [loading, setLoading] = useState(true);
  const isMobileScreen = useCheckMobileScreen();

  useEffect(() => {
    function resetHeight() {
      if (isMobileScreen) {
        document.body.style.overflowY = "scroll";
      }
    }
    window.addEventListener("resize", resetHeight);
    resetHeight();

    getThemColors().then((res: any) => {
      if (res) {
        setRawTheme(res);
        const {
          primary,
          primaryDisabled,
          primaryHover,
          primaryTextColor,
          secondary1,
          secondary1TextColor,
          secondary2,
          secondaryDisabled,
          secondaryHover,
        } = res;
        const updatedTheme = updateTheme(
          primary,
          primaryDisabled,
          primaryHover,
          primaryTextColor,
          secondary1,
          secondary1TextColor,
          secondary2,
          secondaryDisabled,
          secondaryHover
        );
        setTheme(updatedTheme);
        setLoading(false);
      }
    });
  }, []);

  if (!loading) {
    return (
      <ThemeContext.Provider value={{ theme, setTheme, rawTheme, setRawTheme }}>
        <BrowserRouter>
          <GlobalStyle />
          <Routes />
        </BrowserRouter>
      </ThemeContext.Provider>
    );
  } else {
    return <LoaderContainer isLoading={!loading}></LoaderContainer>;
  }
};
